import { createSelector } from '@reduxjs/toolkit';

const selectAuditLog = state => state.eligibility.agentView.auditLog;

export const selectAuditEntries = createSelector(selectAuditLog, auditLog => auditLog.entries);
export const selectAuditLoading = createSelector(selectAuditLog, auditLog => auditLog.isLoading);
export const selectAuditError = createSelector(selectAuditLog, auditLog => auditLog.error);
export const selectAuditStatus = createSelector(selectAuditLog, auditLog => auditLog.status);
export const selectAuditLoaded = createSelector(
  selectAuditLog,
  auditLog => auditLog.status === 'success' || auditLog.status === 'failure',
);
